import type {ComponentProps} from 'react';
import {cn} from '../lib/cn';

export type FormBoxRootProps = ComponentProps<'div'> & {
  nested?: boolean;
};

export function Root({children, nested, className, ...props}: FormBoxRootProps) {
  return (
    <div
      className={cn(
        'flex max-w-[1400px] flex-col items-start gap-6 self-stretch rounded-[var(--form-box-radius)] border border-[var(--form-box-border)] p-6 [container-type:inline-size]',
        nested && 'border-0 p-0',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
